import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SimpleChartIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      fontSize='inherit'
      viewBox='0 0 24 24'
    >
      <path
        d='M16 11.78L20.24 4.45L21.97 5.45L16.74 14.5L10.23 10.75L5.46 19H22V21H2V3H4V17.54L9.5 8L16 11.78Z'
        fill='currentColor'
      />
    </SvgIcon>
  );
};

export default SimpleChartIcon;
